import { IconCrown, IconPackage, IconStarFilled } from "@tabler/icons-react";


export enum EnumTipoContrato {
    Premium = 1,
    Plus = 2,
    Estandar = 3
}

export const TipoContratoColors = {
    [EnumTipoContrato.Premium]: "#ffd90071",
    [EnumTipoContrato.Plus]: "#96c4ffb0",
    [EnumTipoContrato.Estandar]: "#dfdfdfff"
};


export const TipoContratoIconos = {
    [EnumTipoContrato.Premium]: IconCrown,
    [EnumTipoContrato.Plus]: IconStarFilled,
    [EnumTipoContrato.Estandar]: IconPackage
};

export const TipoContratoColoresIconos = {
    [EnumTipoContrato.Premium]: "#7c6a05ff",
    [EnumTipoContrato.Plus]: "#0074d9",
    [EnumTipoContrato.Estandar]: "#292929ff"
};